<div *ngIf="loading && (!router.url.includes('app/admin/agora') || router.url.includes('app/admin/agora/'))"
  class="loading-container flex-content-center flex-center">
  <div class="m-auto center overlay">
    <mat-spinner></mat-spinner>
  </div>
</div>